
// index used for identifying quote item row numbers
var index = 1;

function addNewRFQRow() {
    index += 1;
    console.log("creating new table...");
    var rfqTable = document.getElementById('tbl_body');
    // var next_id = rfqTable.childNodes[rfqTable.childNodes.length-1].nodeValue
    // console.log("next id: " + next_id)
    var newRow = document.createElement('tr');
    var table_default_row_contents = '<td class="rfq-input-cell" >\
                        <input type="text" placeholder="Enter AB #" class="form-input" name="contact[AirBornPart#-' + index + ']">\
                    </td>\
                    <td class="rfq-input-cell">\
                        <input type="text" placeholder="Your Internal #" class="form-input" name="contact[CustomerPart#-' + index + ']">\
                    </td>\
                    <td class="rfq-input-cell">\
                        <input type="number" placeholder="7" class=" qty form-input" name="contact[Qty-' + index + ']">\
                    </td>\
                    <td class="rfq-input-cell">\
                        <input type="checkbox" id="sample" class="form-input" name="contact[Sample-' + index + ']">\
                        <label for="sample">Yes</label>\
                    </td>\
                    <td class="rfq-input-cell">\
                        <input type="date" placeholder="XX/XX/XXXX" class="form-input" name="contact[DeliveryDate-' + index + ']">\
                    </td>\
                    <td class="rfq-input-cell">\
                        <button type="button" id="delete" title="Remove Line Item" class="btn btn--primary w-full md:w-auto"> - </button>\
                    </td>'
    newRow.classList.add('rfq-input-row');
    // newRow.setAttribute("row_id", next_id)
    newRow.innerHTML = table_default_row_contents;
    newRow.lastChild.addEventListener("click", () => { newRow.remove(); })
    rfqTable.appendChild(newRow);
}


function deleteRow1() {
    var firstRow = document.getElementById('rfq-row-1');
    firstRow.remove();
}
